import { SearchIcon } from "lucide-react";

type SearchNoResultsProps = {
  query: string;
};

export function SearchNoResults({ query }: SearchNoResultsProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-4 px-16 py-3xl text-center">
      <div className="rounded-lg border border-border-secondary w-12 h-12 flex items-center justify-center">
        <SearchIcon className="text-fg-quaternary" size={24} />
      </div>
      <div className="flex flex-col gap-xs">
        <span className="text-md font-semibold text-text-primary">
          No results found
        </span>
        <span className="text-sm text-text-tertiary">
          Your search &quot;{query}&quot; did not match any items. Please try
          again with a different term.
        </span>
      </div>
    </div>
  );
}
